export class ToastMessageCloseEvent extends Event {
   static EventName = 'onClose';

   constructor() {
      super(ToastMessageCloseEvent.EventName, {
         bubbles: true,
         composed: true,
      });
   }
}

export class ToastMessageActionEvent extends Event {
   static EventName = 'onBodyCta';

   constructor() {
      super(ToastMessageActionEvent.EventName, {
         bubbles: true,
         composed: true,
      });
   }
}
